import React from 'react'
import clsx from 'clsx'
import { Icon, IconNames, Text } from '@afterpaytouch/core'

import { Trans, useTranslation } from '../../../../utils/convergence'

import styles from './styles.module.css'

export const UniqueSellingPoint = (): JSX.Element | null => {
  const { t } = useTranslation()

  const option = t('educationIntro:usp', {
    returnObjects: true,
    defaultValue: [],
  })

  if (!Array.isArray(option)) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.uspTitle}>
        <Text size='XXXL'>{t('educationIntro:title')}</Text>
      </div>
      <div className={styles.uspDescription}>
        <Text size='XS'>{t('educationIntro:description')}</Text>
      </div>

      <ul className={styles.uspList}>
        {option.map(({ label, icon }: { label: string; icon?: IconNames }, index) => (
          <li key={`usp-item-${index}`} className={clsx(styles.uspItem)}>
            <span className={styles.iconWrapper} key={`usp-item-icon-${index}`}>
              <Icon name={icon} size='Small' />
            </span>
            <span className={styles.uspLabel}>
              <Text renderAs='span'>
                <Trans key={`usp-item-label-${index}`} i18nKey={label} />
              </Text>
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
